import type { SxProps, Theme } from '@mui/material/styles'

/** Merge base layout `sx` with an optional override (array or object). */
export function mergeMuiSx(
  base: SxProps<Theme>,
  override?: SxProps<Theme>
): SxProps<Theme> {
  if (!override) {
    return base
  }
  if (Array.isArray(override)) {
    return [base, ...override] as SxProps<Theme>
  }
  return [base, override] as SxProps<Theme>
}
